/* 布局 */
//前台
import Layout from "@views/layout";

const placoursewarepublicRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "placoursewarepublic",
            name: "PLACOURSEWAREPUBLIC",
            meta: {
                title: "公共资源库",
                sort: 1,
            },
            component: () => import("@views/business/placoursewarepublic/index.vue"),
            redirect: {
                name: "PLACOURSEWAREPUBLIC_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "PLACOURSEWAREPUBLIC_LIST",
                    meta: {
                        title: "公共资源库",
                        sort: 2,
                    },
                    component: () => import("@views/business/placoursewarepublic/list.vue"),
                },
                                {
                    path: "add/:refid",
                    name: "PLACOURSEWAREPUBLIC_ADD",
                    meta: {
                        title: "新增公共资源库",
                        parentPath: '/business/placoursewarepublic/list',
                        operate: true,
                    },
                    component: () => import("@views/business/placoursewarepublic/form.vue"),
                },
                                                {
                    path: "edit/:id",
                    name: "PLACOURSEWAREPUBLIC_EDIT",
                    meta: {
                        title: "编辑公共资源库",
                        parentPath: '/business/placoursewarepublic/list',
                        operate: true,
                    },
                    component: () => import("@views/business/placoursewarepublic/form.vue"),
                },
                                        ],
    },


        ],
};

export default placoursewarepublicRouter;
